import * as Yup from 'yup';


export function initialValues() {//funcion para inicializar los valores de los campos
  return {
    email: '',
    password: '',
  };
}

export function validationSchema() {//funcion para validar los campos
  return Yup.object({
    email: Yup.string().email('El email no es válido').required('Campo requerido'),
    password: Yup.string().required('Campo requerido'),
  });
}